import Model from '@/model/endpointHttp'

class Auth extends Model {
  getWXFaceUrlApi(options = {}) {
    options.baseURL = process.env.VUE_APP_APISERVER
    options.url = '/ums/realnameauth/wx/face'
    return this.get(options)
  }
  getAuthStatusApi(options = {}) {
    options.baseURL = process.env.VUE_APP_APISERVER
    options.url = '/ums/realnameauth/user/verify/info'
    return this.get(options)
  }
  userOcr(options = {}) {
    options.baseURL = process.env.VUE_APP_APISERVER
    options.url = '/user/ocr'
    options.withCredentials = false
    return this.post(options)
  }
  faceAuthApi(options = {}) {
    options.baseURL = process.env.VUE_APP_APISERVER
    options.url = '/user/realnameauth/h5faceparam'
    options.withCredentials = false
    return this.post(options)
  }
  checkIdCardApi(options = {}) {
    options.baseURL = process.env.VUE_APP_APISERVER
    options.url = '/user/realnameauth/checkcard'
    options.withCredentials = false
    return this.post(options)
  }
  authApi(options = {}) {
    options.baseURL = process.env.VUE_APP_APISERVER
    options.url = '/ums/realnameauth'
    return this.post(options)
  }
  uploadImg(options = {}) {
    options.baseURL = process.env.VUE_APP_APISERVER
    options.url = '/ums/realnameauth/qr/pic/upload'
    return this.post(options)
  }
  nationalityApi(options = {}) {
    options.baseURL = process.env.VUE_APP_APISERVER
    options.url = '/user/realnameauth/button/nationality'
    return this.get(options)
  }
  syncPicApi(options = {}) {
    options.baseURL = process.env.VUE_APP_APISERVER
    options.url = '/ums/realnameauth/qr/pic/list'
    return this.get(options)
  }
}

export default new Auth()
